import { Dialog } from '@material-ui/core';
import { DialogTypes } from 'features/eventLive/component/eventLiveCardView';
import { t } from 'i18next';
import { RefObject } from 'react';

interface Props {
	handleDialogState: (param: DialogTypes, isOpen: boolean) => void;
	infoText: string;
	gameTypeDialogRef: RefObject<HTMLDivElement>;
	openGameTypeInfo: boolean;
}

const GameTypeInfoDialog = (props: Props) => {
	const { openGameTypeInfo, gameTypeDialogRef, infoText, handleDialogState } = props;

	return (
		<Dialog
			maxWidth={'xs'}
			fullWidth
			onClose={() => {}}
			className={`custom-dialog bg--transparent custom--box-shadow text--center`}
			aria-labelledby="customized-dialog"
			open={openGameTypeInfo}
		>
			<div className="gametype-info__dialog" ref={gameTypeDialogRef}>
				<div className="gametype-info__dialog-body">
					<div className="gametype-info__dialog-title">
						<p>{t('gameTypeInfoPopupTitle')}</p>
					</div>
					<div className="gametype-info__dialog-description">
						<span dangerouslySetInnerHTML={{ __html: infoText }} />
					</div>
				</div>
				<div className="gametype-info__dialog-footer" onClick={() => handleDialogState('gameType', false)}>
					OK
				</div>
			</div>
		</Dialog>
	);
};

export default GameTypeInfoDialog;
